
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Choice_Completed_Non_Winner = class Notification_Choice_Completed_Non_Winner {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;
        let bid_id = null;

        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.bid_id) {
                bid_id = meta.bid_id;
            }

        } catch (e) {
        }

        if (!_.Notification_Choice_Completed_Non_Winner.denied_modal_init) {
            _.Notification_Choice_Completed_Non_Winner.denied_modal_init = true;
            $("#ac-modal-choice-completed-non-winner-close").click(function (e) {
                e.preventDefault();
                _.Modal.close_unhidable();
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                $(".ac-modal-choice-completed-non-winner-round-number").text(meta.round_number);

                let $items_sold = $("#ac-modal-choice-completed-non-winner-items-list").empty();

                try {
                    for (let item of meta.items_sold) {
                        $items_sold.append($("<li></li>").text(item));
                    }
                } catch (e) {
                    $items_sold.append("<li>(Error loading items list</li>")
                }

                if (meta.paddle_number) {
                    $("#ac-modal-choice-completed-non-winner-message-no-paddle").hide();
                    $("#ac-modal-choice-completed-non-winner-message-with-paddle").show();
                    $(".ac-modal-choice-completed-non-winner-paddle-number").text(meta.paddle_number);
                } else {
                    $("#ac-modal-choice-completed-non-winner-message-no-paddle").show();
                    $("#ac-modal-choice-completed-non-winner-message-with-paddle").hide();
                }

                if (meta.items_remain) {
                    $("#ac-modal-choice-completed-non-winner-no-items-remain").hide();
                    $("#ac-modal-choice-completed-non-winner-next-round-pending").show();
                    $('#ac-modal-choice-completed-non-winner-count-items-remain').text(meta.items_remain);
                } else {
                    $("#ac-modal-choice-completed-non-winner-no-items-remain").show();
                    $("#ac-modal-choice-completed-non-winner-next-round-pending").hide();
                }

                let deferred = $.Deferred();

                $("#ac-modal-choice-completed-non-winner-modal").data('deferred', deferred);

                $("#ac-modal-choice-completed-non-winner-modal").modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
    }
}